module.exports = __webpack_public_path__ + "img/slide_big.f5c72dfb.jpg";